import React from "../../__compat__/react/main.entry.mjs.mjs";
import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { Button } from "../index.mjs.mjs";
const getStyledProductTileTextColor = (props) => {
    switch (props.color) {
        case 'tertiary':
            return props.theme.colors.ui.tertiary;
        default:
            return props.theme.colors.ui.secondary;
    }
};
export const StyledProductTileContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledProductTileContainer", componentId: "auir-611444a-epc6r5" }) `
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: flex-start;
  width: 100%;
  ${injectSpacing('margin')}
`;
export const StyledProductTileInnerContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledProductTileInnerContainer", componentId: "auir-611444a-8a44ox" }) `
  padding: var(${(props) => props.theme.responsive.spacing.l});
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
  flex: 1;
`;
export const StyledProductTileTextContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledProductTileTextContainer", componentId: "auir-611444a-eaftul" }) `
  gap: var(${(props) => props.theme.responsive.spacing.m});
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: flex-start;
  flex: 1;
`;
export const StyledProductTileText = styled.span.withConfig({ displayName: "auir-611444a-StyledProductTileText", componentId: "auir-611444a-myelin" }) `
  display: block;
  color: var(${(props) => getStyledProductTileTextColor(props)});
  ${(props) => injectTypography(props, props.variant)};
  ${({ theme, weight }) => weight &&
    `
      font-weight: var(${theme.fontWeights[weight]})
    `};
`;
export const StyledProductTileButtonContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledProductTileButtonContainer", componentId: "auir-611444a-16gh1zy" }) `
  margin-top: var(${(props) => props.theme.responsive.spacing.xl});
  display: flex;
  flex-direction: column;
  gap: var(${(props) => props.theme.responsive.spacing.xs});
`;
export const StyledPicture = styled.picture.withConfig({ displayName: "auir-611444a-StyledPicture", componentId: "auir-611444a-1vrx9pt" }) `
  width: 100%;
  aspect-ratio: 4/3;
  display: block;
`;
export const StyledImage = styled.img.withConfig({ displayName: "auir-611444a-StyledImage", componentId: "auir-611444a-cogr0w" }) `
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  object-position: bottom center;
`;
export const StyledAnchorTag = styled.a.withConfig({ displayName: "auir-611444a-StyledAnchorTag", componentId: "auir-611444a-1h34b5d" }) `
  text-decoration: none;

  ${({ isImageLink, theme }) => !isImageLink &&
    `
    &:hover {
      ${StyledProductTileText} {
        color: var(${theme.colors.interaction.primary.hover});
      }
    }
  `}
`;
export const StyledTag = styled.div.withConfig({ displayName: "auir-611444a-StyledTag", componentId: "auir-611444a-xqznlg" }) `
  color: var(${(props) => props.theme.colors.ui.secondary});
  background-color: var(${(props) => props.theme.colors.background.level[3]});
  padding: 2px var(${(props) => props.theme.responsive.spacing.s});
  ${(props) => injectTypography(props, 'copy2')};
`;
export const StyledTagAndButtonContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledTagAndButtonContainer", componentId: "auir-611444a-ytxnkq" }) `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: absolute;
  top: var(${(props) => props.theme.responsive.spacing.l});
  right: var(${(props) => props.theme.responsive.spacing.l});
  left: var(${(props) => props.theme.responsive.spacing.l});
  gap: var(${(props) => props.theme.responsive.spacing.l});
`;
export const StyledButtonContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledButtonContainer", componentId: "auir-611444a-18v61a6" }) `
  position: relative;
  &:first-child {
    margin-left: auto;
  }
`;
export const StyledButton = styled((props) => React.createElement(Button, { ...props })).withConfig({ displayName: "auir-611444a-StyledButton", componentId: "auir-611444a-1w4mq03" }) `
  &:first-child {
    margin-left: auto;
  }
`;
//# sourceMappingURL=ProductTile.styles.mjs.mjs.map